import general from 'config/general';

let company = general.company_name;

export default {
  LandingPage: {
    route: {
      path: '/',
      isEnabled: true,
      onlyAuthUsers: false
    },
    pageTitle: 'Landing Page'
  },
  Login: {
    route: {
      path: '/login',
      isEnabled: true,
      onlyAuthUsers: false
    },
    pageTitle: 'Login'
  },
  Register: {
    route: {
      path: '/register',
      isEnabled: true,
      onlyAuthUsers: false
    },
    pageTitle: 'Register'
  },
  CreateAccountWelcome: {
    route: {
      path: '/welcome',
      isEnabled: true,
      onlyAuthUsers: false
    },
    pageTitle: 'Welcome'
  },
  ForgotPassword: {
    route: {
      path: '/forgot-password',
      isEnabled: true,
      onlyAuthUsers: false
    },
    pageTitle: 'Forgot Password'
  },
  Appointments: {
    route: {
      path: '/appointments',
      isEnabled: true,
      onlyAuthUsers: false
    },
    pageTitle: 'Appointments'
  },
  Profile: {
    route: {
      path: '/profile',
      isEnabled: true,
      onlyAuthUsers: false
    },
    pageTitle: 'Profile'
  },
  Settings: {
    route: {
      path: '/settings',
      isEnabled: true,
      onlyAuthUsers: false
    },
    pageTitle: 'Settings',
    noSidebar: true
  },
  Patients: {
    route: {
      path: '/patients',
      isEnabled: true,
      onlyAuthUsers: false
    },
    pageTitle: 'Patients'
  },
  Finances: {
    route: {
      path: '/finances',
      isEnabled: true,
      onlyAuthUsers: false
    },
    pageTitle: 'Finances'
  },
  TeleConsult: {
    route: {
      path: '/teleconsult',
      isEnabled: true,
      onlyAuthUsers: false
    },
    pageTitle: 'Teleconsult'
  },
  HAYFT: {
    route: {
      path: '/hayft',
      isEnabled: true,
      onlyAuthUsers: false
    },
    pageTitle: 'HAYFT'
  },
  NotFound: {
    route: {
      path: '/not-found',
      isEnabled: true,
      onlyAuthUsers: false
    },
    pageTitle: 'Not Found',
    mainText: '404: The page you are looking for isn’t here',
    description: `You either tried some shady route or you came here by mistake.
    Whichever it is, try using the navigation`,
    imageUrl: `/images/undraw_page_not_found_su7k.svg`
  }
};

function getRandomNumber(min = 1, max = 10) {
  // return Math.floor(Math.random() * 9 + 1);
  // random between 1 and 10
  // between min and max where min is included

  let num = Math.random() * (max - min) + min;
  return Math.floor(num);
}
